import { render } from "./MedNyttCatalogPage.vue?vue&type=template&id=3b7ef6ee"
import script from "./MedNyttCatalogPage.vue?vue&type=script&lang=js"
export * from "./MedNyttCatalogPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__